// Configuraicon notificaciones https://www.npmjs.com/package/vue-toastr-2
var notificationOptions = {
  timeOut: 5000,
  extendedTimeOut: 6000,
  closeButton: true,
  preventDuplicates: true,
  positionClass: 'toast-top-right'
};

function notificarError(context, error) {
  const h = context.$createElement;
  var message = 'Se ha produccido un error';
  var detail;

  if (error.response) {
    if (error.response.data.title) {
      message = error.response.data.title;
      detail = error.response.data.detail;
    } else if (error.response.data.errores) {
      var errores = error.response.data.errores.map(element => element.descripcion);
      detail = '';
      for (let e in errores) {
        detail += '<li>' + errores[e] + '</li>';
      }
      detail = '<lu>' + detail + '</lu>';
    }
    // Errores
    context.$toastr.error(detail, message, notificationOptions);
  } else if (error === 'Su sesión ha caducado') {
    context.$message({
      type: 'warning',
      duration: 8000,
      message: h('p', null, [h('span', null, error)])
    });
  } else {
    context.$message({
      type: 'error',
      duration: 8000,
      message: h('p', null, [h('span', null, message)])
    });
  }
}

function notificarSuccess(context, titulo, mensaje) {
  context.$toastr.success(mensaje, titulo, notificationOptions);
}
function notificarWarning(context, titulo, mensaje) {
  context.$toastr.warning(mensaje, titulo, notificationOptions);
}

export { notificarError, notificarSuccess, notificarWarning };
